import { EIcon } from '@NGComponents/NGIcon/NGIcon.enum';
import { ESize, ESubmenuType } from '@NGUtils/enums';
import OverviewCard from '@components/globals/OverviewCard';
import { IOverviewCard } from '@components/globals/OverviewCard/OverviewCard.type';
import SubpageContainer from '@components/globals/SubpageContainer';
import Slider from '@components/slider/Slider';
import Spacing from '@layouts/Spacing';
import { APP_LINKS, APP_SUB_MENUS } from '@utils/variables';
import { FC } from 'react';
import { pushURL } from 'src/functions/functions';
import { StyledCardList } from './HomeOverview.styles';
import { IHomeOverview } from './HomeOverview.type';

const OVERVIEW_CARDS: IOverviewCard[] = [
	{
		title: 'Quests',
		description:
			'Uncover the secrets of Web3 through epic fantasy quests. Earn rewards and level up your Smart Contract skills in this immersive learning experience.',
		imageSrc: '/assets/devhub/quests.svg',
		icon: EIcon.quests2,
		appLink: APP_LINKS.devhub.href,
		targetSubmenu: APP_SUB_MENUS.devhub.campaigns,
		dataCy: 'home-overview-card-devhub'
	},
	{
		title: 'Character',
		description: 'Unlock rewards and forge legendary equipment. Customize your avatar and conquer the realm of Web3.',
		imageSrc: '/assets/devhub/campaigns.svg',
		icon: EIcon.helmet,
		appLink: APP_LINKS.character.href,
		targetSubmenu: APP_SUB_MENUS.character.inventory,
		dataCy: 'home-overview-card-character'
	},
	{
		title: 'Journal',
		description:
			'Track your progress and achievements, and reflect on your conquests while you grow as a skilled smart contract developer.',
		imageSrc: '/assets/devhub/skill-tree.svg',
		icon: EIcon.journal,
		appLink: APP_LINKS.journal.href,
		targetSubmenu: APP_SUB_MENUS.journal.statistics,
		dataCy: 'home-overview-card-journal'
	}
];

const HomeOverview: FC<IHomeOverview> = ({ data }) => {
	return (
		<SubpageContainer type={ESubmenuType.homeOverview}>
			<Slider news={data} />

			<Spacing size={ESize.s} mdSize={ESize.unset} />

			<StyledCardList>
				{OVERVIEW_CARDS.map((card) => (
					<OverviewCard key={card.title} onClick={(appLink, newSubmenu) => pushURL(appLink, newSubmenu.id)} {...card} />
				))}
			</StyledCardList>
		</SubpageContainer>
	);
};

export { HomeOverview };
